import basic from './basic'

export default {
  type: 'widget',

  mixins: [basic]
}
